import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import './App.css'
import Products from './Pages/Products'
import AboutUs from './Pages/AboutUs'
import ContactUs from './Pages/ContactUs'
import Affiliate from "./Pages/Affiliate"
import Layout from './Component/Layout'
import Home from "./Pages/Home"

function App() {

  return (
    <>
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/products" element={<Products />} />
            <Route path="/affiliate" element={<Affiliate />} />
            <Route path="/contactus" element={<ContactUs />} />
          </Route>
        </Routes>
      </Router>


    </>
  )
}

export default App
